import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import styles from "./podcastSec.module.css";
import PodcastCard from './PodcastCard';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import useTextAnimation from "../../hooks/useTextAnimation.js";

import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { IMAGE_URL } from '../../helpers/api_helper.jsx';
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_EN } from '../../helpers/constant';

const PodcastSec = ({ podCards, banner, bannerMob, heading }) => {


    const { ref: headingRef, inView: headingInView, textAnimation } = useTextAnimation();
     const { t, i18n } = useTranslation();
    


    return (
        <div className={styles.podcast_inner}>
            <div className={styles.podcast_loop}>
                <div className={styles.podcast_banner}>
                    {/*  <img className={styles.podcast_bannerDesk} src={banner} alt="" />
                    <img className={styles.podcast_bannerMob} src={bannerMob} alt="" /> */}

                    <img className={styles.podcast_bannerDesk} src={`${IMAGE_URL}/podcast/${banner}`} alt=""  loading='lazy'/>
                    <img className={styles.podcast_bannerMob} src={`${IMAGE_URL}/podcast/${bannerMob}`} alt="" loading='lazy'/>


                    <div className={`${styles.podcast_bannerTxt} `}>
                        <motion.h1
                            ref={headingRef}
                            initial="hidden"
                            animate={headingInView ? "visible" : "hidden"}
                            custom={0}
                            variants={textAnimation}
                        >{heading}</motion.h1>
                    </div>
                </div>
                <div className={styles.podcast_listing}>
                    <ul className={styles.podcast_list}>
                        {/* <Swiper
                            spaceBetween={68}
                            slidesPerView={Math.min(podCards.length, 2)}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            breakpoints={{
                                320: { slidesPerView: 1 },
                                900: { slidesPerView: Math.min(podCards.length, 2) },
                                1024: { slidesPerView: Math.min(podCards.length, 2), spaceBetween: 30 },
                            }}
                            navigation={false}
                            pagination={false}
                            modules={[Autoplay, Navigation, Pagination]}
                            className={styles.mySwiper}
                        > */}
                        {podCards.map((pod) => (
                            <li key={pod._id}>
                                <PodcastCard
                                    image={pod.image}
                                    ep={pod.episodeNo}
                                    /* title={pod.title}
                                    content={pod.description} */
                                    title={i18n.language === LANG_EN ? pod.title : pod.titleAr}
                                    content={i18n.language === LANG_EN ? pod.description : pod.descriptionAr}

                                    platforms={pod?.platforms}
                                />
                            </li>
                        ))}
                        {/* </Swiper> */}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default PodcastSec
